import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {ButtonComponent, MODAL_DATA, ModalRef} from '@sms-ir/ui-components';

export interface DeleteModalData {
  modalHeader: string;
  modalText: string;
  modalConfirmButton?: string;
  modalCancelButton?: string;
}

@Component({
  selector: 'app-delete-modal',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './delete-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteModalComponent {
  private readonly modalRef = inject<ModalRef<boolean>>(ModalRef);
  private readonly data = inject<DeleteModalData>(MODAL_DATA);

  readonly modalHeader = this.data.modalHeader;
  readonly modalText = this.data.modalText;
  readonly modalConfirmButton = this.data.modalConfirmButton;
  readonly modalCancelButton = this.data.modalCancelButton;

  onSubmit(): void {
    this.modalRef.close(true);
  }

  onCancel(): void {
    this.modalRef.close(false);
  }
}
